import React from 'react';
import { PERFORMANCE_LAB_MAPS_PRECONNECT_ORIGINS } from './performanceLabMaps';

export const PerformanceLabMapsPreconnect: React.FC = () => (
  <>
    {PERFORMANCE_LAB_MAPS_PRECONNECT_ORIGINS.map((href) => (
      <link key={href} rel="preconnect" href={href} crossOrigin="anonymous" />
    ))}
  </>
);
